<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="halftitlepage" id="bkht">
<h1 class="bkht"><a class="page" id="pi"></a>Pillars of Cloud and Fire</h1>
<p class="sert"><a class="page" id="pii"></a>RELIGION AND SOCIAL TRANSFORMATION</p>
<p class="serau">General Editors: Anthony B. Pinn and Stacey M. Floyd-Thomas</p>
<p class="ser">Prophetic Activism: Progressive Religious Justice Movements in Contemporary America</p>
<p class="serau">Helene Slessarev-Jamir</p>
<p class="ser">All You That Labor: Religious Activists and Theological Ethics in the U.S. Living Wage Movement</p>
<p class="serau">C. Melissa Snarr</p>
<p class="ser">Blacks and Whites in Christian America: How the Legacy of Discrimination Has Shaped African Americans’ Religious Thoughts and Practices</p>
<p class="serau">James E. Shelton and Michael O. Emerson</p>
<p class="ser">Pillars of Cloud and Fire: The Politics of Exodus in African American Biblical Interpretation</p>
<p class="serau">Herbert Robinson Marbury</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Marbury-0002.vue?b0df517c